/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const PageLayout = styled.div`
  padding: 30px 0px;
`;
